import { mergeStyles } from 'wix-rich-content-common';
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import { decorateComponentWithProps } from 'wix-rich-content-editor-common';
import React from 'react';
import PropTypes from 'prop-types';
import require$$0 from '@wix/draft-js';
import require$$3 from 'lodash/escapeRegExp';
import { a as addMention, g as getSearchText, b as getTypeByTrigger } from './addMention-d507fa95.js';
import require$$2 from 'immutable';
import { DEFAULT_SETTINGS, DEFAULTS } from './defaultSettings.js';
import { MENTION_TYPE, EXTERNAL_MENTIONS_TYPE } from './types.js';
import { positionSuggestions as positionSuggestions$2 } from './positionSuggestions.js';
import MentionComponent from './MentionComponent.js';
import MentionSuggestionsWrapper from './MentionSuggestionsWrapper.js';
import { s as styles } from './mentions-4e4bdc50.js';
import 'classnames';
import './style-inject.es-746bb8ed.js';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var lib = {};

var MentionSuggestions$1 = {};

var Entry$1 = {};

Object.defineProperty(Entry$1, "__esModule", {
  value: true
});

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$5 = React;

var _react2$5 = _interopRequireDefault$7(_react$5);

var _propTypes$1 = PropTypes;

var _propTypes2$1 = _interopRequireDefault$7(_propTypes$1);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Entry = function (_Component) {
  _inherits$2(Entry, _Component);

  function Entry(props) {
    _classCallCheck$2(this, Entry);

    var _this = _possibleConstructorReturn$2(this, (Entry.__proto__ || Object.getPrototypeOf(Entry)).call(this, props));

    _this.onMouseUp = function () {
      if (_this.mouseDown) {
        _this.props.onMentionSelect(_this.props.mention);
        _this.mouseDown = false;
      }
    };

    _this.onMouseDown = function (event) {
      // Note: important to avoid a content edit change
      event.preventDefault();

      _this.mouseDown = true;
    };

    _this.onMouseEnter = function () {
      _this.props.onMentionFocus(_this.props.index);
    };

    _this.mouseDown = false;
    return _this;
  }

  _createClass$2(Entry, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.mouseDown = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$theme = _props.theme,
          theme = _props$theme === undefined ? {} : _props$theme,
          mention = _props.mention,
          searchValue = _props.searchValue,
          isFocused = _props.isFocused,
          id = _props.id;

      var className = isFocused ? theme.mentionSuggestionsEntryFocused : theme.mentionSuggestionsEntry;
      var EntryComponent = this.props.entryComponent;
      return _react2$5.default.createElement(EntryComponent, {
        className: className,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        onMouseEnter: this.onMouseEnter,
        role: 'option',
        id: id,
        'aria-selected': isFocused ? 'true' : null,
        theme: theme,
        mention: mention,
        isFocused: isFocused,
        searchValue: searchValue
      });
    }
  }]);

  return Entry;
}(_react$5.Component);

Entry.propTypes = {
  entryComponent: _propTypes2$1.default.any.isRequired,
  searchValue: _propTypes2$1.default.string,
  onMentionSelect: _propTypes2$1.default.func
};
Entry$1.default = Entry;

var decodeOffsetKey$1 = {};

Object.defineProperty(decodeOffsetKey$1, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var decodeOffsetKey = function decodeOffsetKey(offsetKey) {
  var _offsetKey$split = offsetKey.split('-'),
      _offsetKey$split2 = _slicedToArray(_offsetKey$split, 3),
      blockKey = _offsetKey$split2[0],
      decoratorKey = _offsetKey$split2[1],
      leafKey = _offsetKey$split2[2];

  return {
    blockKey: blockKey,
    decoratorKey: parseInt(decoratorKey, 10),
    leafKey: parseInt(leafKey, 10)
  };
};

decodeOffsetKey$1.default = decodeOffsetKey;

var defaultEntryComponent$1 = {};

var Avatar$1 = {};

Object.defineProperty(Avatar$1, "__esModule", {
  value: true
});

var _react$4 = React;

var _react2$4 = _interopRequireDefault$6(_react$4);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Avatar = function Avatar(_ref) {
  var mention = _ref.mention,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme;

  if (mention.avatar) {
    return _react2$4.default.createElement("img", {
      src: mention.avatar,
      className: theme.mentionSuggestionsEntryAvatar,
      role: "presentation"
    });
  }

  return null;
};

Avatar$1.default = Avatar;

Object.defineProperty(defaultEntryComponent$1, "__esModule", {
  value: true
});

var _react$3 = React;

var _react2$3 = _interopRequireDefault$5(_react$3);

var _Avatar = Avatar$1;

var _Avatar2 = _interopRequireDefault$5(_Avatar);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultEntryComponent = function defaultEntryComponent(props) {
  var mention = props.mention,
      theme = props.theme;
      props.isFocused;
      props.searchValue;
      var parentProps = _objectWithoutProperties$1(props, ['mention', 'theme', 'isFocused', 'searchValue']);

  return _react2$3.default.createElement(
    'div',
    parentProps,
    _react2$3.default.createElement(_Avatar2.default, { mention: mention, theme: theme }),
    _react2$3.default.createElement(
      'span',
      { className: theme.mentionSuggestionsEntryText },
      mention.name
    )
  );
};

defaultEntryComponent$1.default = defaultEntryComponent;

Object.defineProperty(MentionSuggestions$1, "__esModule", {
  value: true
});
MentionSuggestions$1.MentionSuggestions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$2 = React;

var _react2$2 = _interopRequireDefault$4(_react$2);

var _propTypes = PropTypes;

var _propTypes2 = _interopRequireDefault$4(_propTypes);

var _draftJs = require$$0;

var _escapeRegExp$1 = require$$3;

var _escapeRegExp2$1 = _interopRequireDefault$4(_escapeRegExp$1);

var _Entry = Entry$1;

var _Entry2 = _interopRequireDefault$4(_Entry);

var _addMention = addMention;

var _addMention2 = _interopRequireDefault$4(_addMention);

var _decodeOffsetKey = decodeOffsetKey$1;

var _decodeOffsetKey2 = _interopRequireDefault$4(_decodeOffsetKey);

var _getSearchText2 = getSearchText;

var _getSearchText3 = _interopRequireDefault$4(_getSearchText2);

var _defaultEntryComponent = defaultEntryComponent$1;

var _defaultEntryComponent2 = _interopRequireDefault$4(_defaultEntryComponent);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MentionSuggestions = MentionSuggestions$1.MentionSuggestions = function (_Component) {
  _inherits$1(MentionSuggestions, _Component);

  function MentionSuggestions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1(this, MentionSuggestions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = MentionSuggestions.__proto__ || Object.getPrototypeOf(MentionSuggestions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isActive: false,
      focusedOptionIndex: 0
    }, _this.componentDidUpdate = function (prevProps, prevState) {
      if (_this.popover) {
        // In case the list shrinks there should be still an option focused.
        // Note: this might run multiple times and deduct 1 until the condition is
        // not fullfilled anymore.
        var size = _this.props.suggestions.length;
        if (size > 0 && _this.state.focusedOptionIndex >= size) {
          _this.setState({
            focusedOptionIndex: size - 1
          });
        }

        // Note: this is a simple protection for the error when componentDidUpdate
        // try to get new getPortalClientRect, but the key already was deleted by
        // previous action. (right now, it only can happened when set the mention
        // trigger to be multi-characters which not supported anyway!)
        if (!_this.props.store.getAllSearches().has(_this.activeOffsetKey)) {
          return;
        }

        var decoratorRect = _this.props.store.getPortalClientRect(_this.activeOffsetKey);
        var newStyles = _this.props.positionSuggestions({
          decoratorRect: decoratorRect,
          prevProps: prevProps,
          prevState: prevState,
          props: _this.props,
          state: _this.state,
          popover: _this.popover
        });
        Object.keys(newStyles).forEach(function (key) {
          _this.popover.style[key] = newStyles[key];
        });
      }
    }, _this.componentWillUnmount = function () {
      _this.props.callbacks.onChange = undefined;
    }, _this.onEditorStateChange = function (editorState) {
      var searches = _this.props.store.getAllSearches();

      // if no search portal is active there is no need to show the popover
      if (searches.size === 0) {
        return editorState;
      }

      var removeList = function removeList() {
        _this.props.store.resetEscapedSearch();
        _this.closeDropdown();
        return editorState;
      };

      // get the current selection
      var selection = editorState.getSelection();
      var anchorKey = selection.getAnchorKey();
      var anchorOffset = selection.getAnchorOffset();

      // the list should not be visible if a range is selected or the editor has no focus
      if (!selection.isCollapsed() || !selection.getHasFocus()) return removeList();

      // identify the start & end positon of each search-text
      var offsetDetails = searches.map(function (offsetKey) {
        return (0, _decodeOffsetKey2.default)(offsetKey);
      });

      // a leave can be empty when it is removed due e.g. using backspace
      // do not check leaves, use full decorated portal text
      var leaves = offsetDetails.filter(function (_ref2) {
        var blockKey = _ref2.blockKey;
        return blockKey === anchorKey;
      }).map(function (_ref3) {
        var blockKey = _ref3.blockKey,
            decoratorKey = _ref3.decoratorKey;
        return editorState.getBlockTree(blockKey).getIn([decoratorKey]);
      });

      // if all leaves are undefined the popover should be removed
      if (leaves.every(function (leave) {
        return leave === undefined;
      })) {
        return removeList();
      }

      // Checks that the cursor is after the @ character but still somewhere in
      // the word (search term). Setting it to allow the cursor to be left of
      // the @ causes troubles due selection confusion.
      var plainText = editorState.getCurrentContent().getPlainText();
      var selectionIsInsideWord = leaves.filter(function (leave) {
        return leave !== undefined;
      }).map(function (_ref4) {
        var start = _ref4.start,
            end = _ref4.end;
        return start === 0 && anchorOffset === _this.props.mentionTrigger.length && plainText.charAt(anchorOffset) !== _this.props.mentionTrigger && new RegExp(String.raw({ raw: '' + (0, _escapeRegExp2$1.default)(_this.props.mentionTrigger) }), 'g').test(plainText) && anchorOffset <= end || // @ is the first character
        anchorOffset > start + _this.props.mentionTrigger.length && anchorOffset <= end;
      } // @ is in the text or at the end
      );

      if (selectionIsInsideWord.every(function (isInside) {
        return isInside === false;
      })) return removeList();

      var lastActiveOffsetKey = _this.activeOffsetKey;
      _this.activeOffsetKey = selectionIsInsideWord.filter(function (value) {
        return value === true;
      }).keySeq().first();

      _this.onSearchChange(editorState, selection, _this.activeOffsetKey, lastActiveOffsetKey);

      // make sure the escaped search is reseted in the cursor since the user
      // already switched to another mention search
      if (!_this.props.store.isEscaped(_this.activeOffsetKey)) {
        _this.props.store.resetEscapedSearch();
      }

      // If none of the above triggered to close the window, it's safe to assume
      // the dropdown should be open. This is useful when a user focuses on another
      // input field and then comes back: the dropdown will show again.
      if (!_this.state.isActive && !_this.props.store.isEscaped(_this.activeOffsetKey) && _this.props.suggestions.length > 0) {
        _this.openDropdown();
      }

      // makes sure the focused index is reseted every time a new selection opens
      // or the selection was moved to another mention search
      if (_this.lastSelectionIsInsideWord === undefined || !selectionIsInsideWord.equals(_this.lastSelectionIsInsideWord)) {
        _this.setState({
          focusedOptionIndex: 0
        });
      }

      _this.lastSelectionIsInsideWord = selectionIsInsideWord;

      return editorState;
    }, _this.onSearchChange = function (editorState, selection, activeOffsetKey, lastActiveOffsetKey) {
      var _getSearchText = (0, _getSearchText3.default)(editorState, selection, _this.props.mentionTrigger),
          searchValue = _getSearchText.matchingString;

      if (_this.lastSearchValue !== searchValue || activeOffsetKey !== lastActiveOffsetKey) {
        _this.lastSearchValue = searchValue;
        _this.props.onSearchChange({ value: searchValue });
      }
    }, _this.onDownArrow = function (keyboardEvent) {
      keyboardEvent.preventDefault();
      var newIndex = _this.state.focusedOptionIndex + 1;
      _this.onMentionFocus(newIndex >= _this.props.suggestions.length ? 0 : newIndex);
    }, _this.onTab = function (keyboardEvent) {
      keyboardEvent.preventDefault();
      _this.commitSelection();
    }, _this.onUpArrow = function (keyboardEvent) {
      keyboardEvent.preventDefault();
      if (_this.props.suggestions.length > 0) {
        var newIndex = _this.state.focusedOptionIndex - 1;
        _this.onMentionFocus(newIndex < 0 ? _this.props.suggestions.length - 1 : newIndex);
      }
    }, _this.onEscape = function (keyboardEvent) {
      keyboardEvent.preventDefault();

      var activeOffsetKey = _this.lastSelectionIsInsideWord.filter(function (value) {
        return value === true;
      }).keySeq().first();
      _this.props.store.escapeSearch(activeOffsetKey);
      _this.closeDropdown();

      // to force a re-render of the outer component to change the aria props
      _this.props.store.setEditorState(_this.props.store.getEditorState());
    }, _this.onMentionSelect = function (mention) {
      // Note: This can happen in case a user typed @xxx (invalid mention) and
      // then hit Enter. Then the mention will be undefined.
      if (!mention) {
        return;
      }

      if (_this.props.onAddMention) {
        _this.props.onAddMention(mention);
      }

      _this.closeDropdown();
      var newEditorState = (0, _addMention2.default)(_this.props.store.getEditorState(), mention, _this.props.mentionPrefix, _this.props.mentionTrigger, _this.props.entityMutability);
      _this.props.store.setEditorState(newEditorState);
    }, _this.onMentionFocus = function (index) {
      var descendant = 'mention-option-' + _this.key + '-' + index;
      _this.props.ariaProps.ariaActiveDescendantID = descendant;
      _this.setState({
        focusedOptionIndex: index
      });

      // to force a re-render of the outer component to change the aria props
      _this.props.store.setEditorState(_this.props.store.getEditorState());
    }, _this.commitSelection = function () {
      if (!_this.props.store.getIsOpened()) {
        return 'not-handled';
      }

      _this.onMentionSelect(_this.props.suggestions[_this.state.focusedOptionIndex]);
      return 'handled';
    }, _this.openDropdown = function () {
      // This is a really nasty way of attaching & releasing the key related functions.
      // It assumes that the keyFunctions object will not loose its reference and
      // by this we can replace inner parameters spread over different modules.
      // This better be some registering & unregistering logic. PRs are welcome :)
      _this.props.callbacks.handleReturn = _this.commitSelection;
      _this.props.callbacks.keyBindingFn = function (keyboardEvent) {
        // arrow down
        if (keyboardEvent.keyCode === 40) {
          _this.onDownArrow(keyboardEvent);
        }
        // arrow up
        if (keyboardEvent.keyCode === 38) {
          _this.onUpArrow(keyboardEvent);
        }
        // escape
        if (keyboardEvent.keyCode === 27) {
          _this.onEscape(keyboardEvent);
        }
        // tab
        if (keyboardEvent.keyCode === 9) {
          _this.onTab(keyboardEvent);
        }
      };

      var descendant = 'mention-option-' + _this.key + '-' + _this.state.focusedOptionIndex;
      _this.props.ariaProps.ariaActiveDescendantID = descendant;
      _this.props.ariaProps.ariaOwneeID = 'mentions-list-' + _this.key;
      _this.props.ariaProps.ariaHasPopup = 'true';
      _this.props.ariaProps.ariaExpanded = true;
      _this.setState({
        isActive: true
      });

      if (_this.props.onOpen) {
        _this.props.onOpen();
      }
    }, _this.closeDropdown = function () {
      // make sure none of these callbacks are triggered
      _this.props.callbacks.handleReturn = undefined;
      _this.props.callbacks.keyBindingFn = undefined;
      _this.props.ariaProps.ariaHasPopup = 'false';
      _this.props.ariaProps.ariaExpanded = false;
      _this.props.ariaProps.ariaActiveDescendantID = undefined;
      _this.props.ariaProps.ariaOwneeID = undefined;
      _this.setState({
        isActive: false
      });

      if (_this.props.onClose) {
        _this.props.onClose();
      }
    }, _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$1(MentionSuggestions, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.key = (0, _draftJs.genKey)();
      this.props.callbacks.onChange = this.onEditorStateChange;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.suggestions.length === 0 && this.state.isActive) {
        this.closeDropdown();
      } else if (nextProps.suggestions.length > 0 && nextProps.suggestions !== this.props.suggestions && !this.state.isActive) {
        this.openDropdown();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.state.isActive) {
        return null;
      }

      var _props = this.props,
          entryComponent = _props.entryComponent,
          _props$popoverCompone = _props.popoverComponent,
          popoverComponent = _props$popoverCompone === undefined ? _react2$2.default.createElement('div', null) : _props$popoverCompone;
          _props.onClose;
          _props.onOpen;
          _props.onAddMention;
          _props.onSearchChange;
          _props.suggestions;
          _props.ariaProps;
          _props.callbacks;
          var _props$theme = _props.theme,
          theme = _props$theme === undefined ? {} : _props$theme;
          _props.store;
          _props.entityMutability;
          _props.positionSuggestions;
          _props.mentionTrigger;
          _props.mentionPrefix;
          var elementProps = _objectWithoutProperties(_props, ['entryComponent', 'popoverComponent', 'onClose', 'onOpen', 'onAddMention', 'onSearchChange', 'suggestions', 'ariaProps', 'callbacks', 'theme', 'store', 'entityMutability', 'positionSuggestions', 'mentionTrigger', 'mentionPrefix']);

      return _react2$2.default.cloneElement(popoverComponent, _extends({}, elementProps, {
        className: theme.mentionSuggestions,
        role: 'listbox',
        id: 'mentions-list-' + this.key,
        ref: function ref(element) {
          _this2.popover = element;
        }
      }), this.props.suggestions.map(function (mention, index) {
        return _react2$2.default.createElement(_Entry2.default, {
          key: mention.id != null ? mention.id : mention.name,
          onMentionSelect: _this2.onMentionSelect,
          onMentionFocus: _this2.onMentionFocus,
          isFocused: _this2.state.focusedOptionIndex === index,
          mention: mention,
          index: index,
          id: 'mention-option-' + _this2.key + '-' + index,
          theme: theme,
          searchValue: _this2.lastSearchValue,
          entryComponent: entryComponent || _defaultEntryComponent2.default
        });
      }));
    }
  }]);

  return MentionSuggestions;
}(_react$2.Component);

MentionSuggestions.propTypes = {
  entityMutability: _propTypes2.default.oneOf(['SEGMENTED', 'IMMUTABLE', 'MUTABLE']),
  entryComponent: _propTypes2.default.func,
  onAddMention: _propTypes2.default.func,
  suggestions: _propTypes2.default.array
};
MentionSuggestions$1.default = MentionSuggestions;

var Mention$1 = {};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

var clsx_m = /*#__PURE__*/Object.freeze({
	__proto__: null,
	clsx: clsx,
	default: clsx
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(clsx_m);

Object.defineProperty(Mention$1, "__esModule", {
  value: true
});

var _react$1 = React;

var _react2$1 = _interopRequireDefault$3(_react$1);

var _clsx = require$$1;

var _clsx2 = _interopRequireDefault$3(_clsx);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MentionLink = function MentionLink(_ref) {
  var mention = _ref.mention,
      children = _ref.children,
      className = _ref.className;
  return _react2$1.default.createElement(
    'a',
    { href: mention.link, className: className, spellCheck: false },
    children
  );
};

var MentionText = function MentionText(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return _react2$1.default.createElement(
    'span',
    { className: className, spellCheck: false },
    children
  );
};

var Mention = function Mention(props) {
  var entityKey = props.entityKey,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? {} : _props$theme,
      mentionComponent = props.mentionComponent,
      children = props.children,
      decoratedText = props.decoratedText,
      className = props.className,
      contentState = props.contentState;


  var combinedClassName = (0, _clsx2.default)(theme.mention, className);
  var mention = contentState.getEntity(entityKey).getData().mention;

  var Component = mentionComponent || (mention.link ? MentionLink : MentionText);

  return _react2$1.default.createElement(
    Component,
    {
      entityKey: entityKey,
      mention: mention,
      theme: theme,
      className: combinedClassName,
      decoratedText: decoratedText
    },
    children
  );
};

Mention$1.default = Mention;

var MentionSuggestionsPortal$1 = {};

Object.defineProperty(MentionSuggestionsPortal$1, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React;

var _react2 = _interopRequireDefault$2(_react);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MentionSuggestionsPortal = function (_Component) {
  _inherits(MentionSuggestionsPortal, _Component);

  function MentionSuggestionsPortal(props) {
    _classCallCheck(this, MentionSuggestionsPortal);

    // Note: this is a workaround for an obscure issue: https://github.com/draft-js-plugins/draft-js-plugins/pull/667/files
    // Ideally we can remove this in the future.
    var _this = _possibleConstructorReturn(this, (MentionSuggestionsPortal.__proto__ || Object.getPrototypeOf(MentionSuggestionsPortal)).call(this, props));

    _this.searchPortalRef = function (element) {
      _this.searchPortal = element;
    };
    return _this;
  }

  // When inputting Japanese characters (or any complex alphabet which requires
  // hitting enter to commit the characters), that action was causing a race
  // condition when we used componentWillMount. By using componentDidMount
  // instead of componentWillMount, the component will unmount unregister and
  // then properly mount and register after. Prior to this change,
  // componentWillMount would not fire after componentWillUnmount even though it
  // was still in the DOM, so it wasn't re-registering the offsetkey.


  _createClass(MentionSuggestionsPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.store.register(this.props.offsetKey);
      this.props.store.setIsOpened(true);
      this.updatePortalClientRect(this.props);

      // trigger a re-render so the MentionSuggestions becomes active
      this.props.setEditorState(this.props.getEditorState());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updatePortalClientRect(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.unregister(this.props.offsetKey);
      this.props.store.setIsOpened(false);
    }
  }, {
    key: 'updatePortalClientRect',
    value: function updatePortalClientRect(props) {
      var _this2 = this;

      this.props.store.updatePortalClientRect(props.offsetKey, function () {
        return _this2.searchPortal.getBoundingClientRect();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { className: this.key, ref: this.searchPortalRef },
        this.props.children
      );
    }
  }]);

  return MentionSuggestionsPortal;
}(_react.Component);

MentionSuggestionsPortal$1.default = MentionSuggestionsPortal;

var defaultRegExp = {};

Object.defineProperty(defaultRegExp, "__esModule", {
  value: true
});
defaultRegExp.default = '[' + '\\w-' +
// Latin-1 Supplement (letters only) - https://en.wikipedia.org/wiki/List_of_Unicode_characters#Latin-1_Supplement
'\xC0-\xD6' + '\xD8-\xF6' + '\xF8-\xFF' +
// Latin Extended-A (without deprecated character) - https://en.wikipedia.org/wiki/List_of_Unicode_characters#Latin_Extended-A
'\u0100-\u0148' + '\u014A-\u017F' +
// Cyrillic symbols: \u0410-\u044F - https://en.wikipedia.org/wiki/Cyrillic_script_in_Unicode
'\u0410-\u044F' +
// hiragana (japanese): \u3040-\u309F - https://gist.github.com/ryanmcgrath/982242#file-japaneseregex-js
'\u3040-\u309F' +
// katakana (japanese): \u30A0-\u30FF - https://gist.github.com/ryanmcgrath/982242#file-japaneseregex-js
'\u30A0-\u30FF' +
// For an advanced explaination about Hangul see https://github.com/draft-js-plugins/draft-js-plugins/pull/480#issuecomment-254055437
// Hangul Jamo (korean): \u3130-\u318F - https://en.wikipedia.org/wiki/Korean_language_and_computers#Hangul_in_Unicode
// Hangul Syllables (korean): \uAC00-\uD7A3 - https://en.wikipedia.org/wiki/Korean_language_and_computers#Hangul_in_Unicode
'\u3130-\u318F' + '\uAC00-\uD7A3' +
// common chinese symbols: \u4e00-\u9eff - http://stackoverflow.com/a/1366113/837709
'\u4E00-\u9EFF' + ']*';

var mentionStrategy = {};

Object.defineProperty(mentionStrategy, "__esModule", {
  value: true
});

var _getTypeByTrigger = getTypeByTrigger;

var _getTypeByTrigger2 = _interopRequireDefault$1(_getTypeByTrigger);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findMentionEntities = function findMentionEntities(trigger) {
  return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === (0, _getTypeByTrigger2.default)(trigger);
    }, callback);
  };
};

mentionStrategy.default = findMentionEntities;

var mentionSuggestionsStrategy = {};

Object.defineProperty(mentionSuggestionsStrategy, "__esModule", {
  value: true
});

var _escapeRegExp = require$$3;

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findWithRegex = function findWithRegex(regex, contentBlock, callback) {
  var contentBlockText = contentBlock.getText();

  // exclude entities, when matching
  contentBlock.findEntityRanges(function (character) {
    return !character.getEntity();
  }, function (nonEntityStart, nonEntityEnd) {
    var text = contentBlockText.slice(nonEntityStart, nonEntityEnd);
    var matchArr = void 0;
    var start = void 0;
    var prevLastIndex = regex.lastIndex;

    // Go through all matches in the text and return the indices to the callback
    // Break the loop if lastIndex is not changed
    while ((matchArr = regex.exec(text)) !== null) {
      // eslint-disable-line
      if (regex.lastIndex === prevLastIndex) {
        break;
      }
      prevLastIndex = regex.lastIndex;
      start = nonEntityStart + matchArr.index;
      callback(start, start + matchArr[0].length);
    }
  });
};

mentionSuggestionsStrategy.default = function (trigger, supportWhiteSpace, regExp) {
  //eslint-disable-line
  var MENTION_REGEX = supportWhiteSpace ? new RegExp((0, _escapeRegExp2.default)(trigger) + '(' + regExp + '|\\s){0,}', 'g') : new RegExp('(\\s|^)' + (0, _escapeRegExp2.default)(trigger) + regExp, 'g');

  return function (contentBlock, callback) {
    findWithRegex(MENTION_REGEX, contentBlock, callback);
  };
};

var defaultSuggestionsFilter$1 = {};

Object.defineProperty(defaultSuggestionsFilter$1, "__esModule", {
  value: true
});
// Get the first 5 suggestions that match

var defaultSuggestionsFilter = function defaultSuggestionsFilter(searchValue, suggestions) {
  var value = searchValue.toLowerCase();
  var filteredSuggestions = suggestions.filter(function (suggestion) {
    return !value || suggestion.name.toLowerCase().indexOf(value) > -1;
  });
  var length = filteredSuggestions.length < 5 ? filteredSuggestions.length : 5;
  return filteredSuggestions.slice(0, length);
};

defaultSuggestionsFilter$1.default = defaultSuggestionsFilter;

var positionSuggestions$1 = {};

Object.defineProperty(positionSuggestions$1, "__esModule", {
  value: true
});
var getRelativeParent = function getRelativeParent(element) {
  if (!element) {
    return null;
  }

  var position = window.getComputedStyle(element).getPropertyValue('position');
  if (position !== 'static') {
    return element;
  }

  return getRelativeParent(element.parentElement);
};

var positionSuggestions = function positionSuggestions(_ref) {
  var decoratorRect = _ref.decoratorRect,
      popover = _ref.popover,
      state = _ref.state,
      props = _ref.props;

  var relativeParent = getRelativeParent(popover.parentElement);
  var relativeRect = {};

  if (relativeParent) {
    relativeRect.scrollLeft = relativeParent.scrollLeft;
    relativeRect.scrollTop = relativeParent.scrollTop;

    var relativeParentRect = relativeParent.getBoundingClientRect();
    relativeRect.left = decoratorRect.left - relativeParentRect.left;
    relativeRect.top = decoratorRect.bottom - relativeParentRect.top;
  } else {
    relativeRect.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    relativeRect.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    relativeRect.top = decoratorRect.bottom;
    relativeRect.left = decoratorRect.left;
  }

  var left = relativeRect.left + relativeRect.scrollLeft;
  var top = relativeRect.top + relativeRect.scrollTop;

  var transform = void 0;
  var transition = void 0;
  if (state.isActive) {
    if (props.suggestions.length > 0) {
      transform = 'scale(1)';
      transition = 'all 0.25s cubic-bezier(.3,1.2,.2,1)';
    } else {
      transform = 'scale(0)';
      transition = 'all 0.35s cubic-bezier(.3,1,.2,1)';
    }
  }

  return {
    left: left + 'px',
    top: top + 'px',
    transform: transform,
    transformOrigin: '1em 0%',
    transition: transition
  };
};

positionSuggestions$1.default = positionSuggestions;

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultSuggestionsFilter = exports.defaultTheme = exports.MentionSuggestions = undefined;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line import/no-named-as-default


	var _MentionSuggestions = MentionSuggestions$1;

	Object.defineProperty(exports, 'MentionSuggestions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MentionSuggestions).default;
	  }
	});

	var _react = React;

	var _react2 = _interopRequireDefault(_react);

	var _immutable = require$$2;

	var _Mention = Mention$1;

	var _Mention2 = _interopRequireDefault(_Mention);

	var _MentionSuggestions2 = _interopRequireDefault(_MentionSuggestions);

	var _MentionSuggestionsPortal = MentionSuggestionsPortal$1;

	var _MentionSuggestionsPortal2 = _interopRequireDefault(_MentionSuggestionsPortal);

	var _defaultRegExp = defaultRegExp;

	var _defaultRegExp2 = _interopRequireDefault(_defaultRegExp);

	var _mentionStrategy = mentionStrategy;

	var _mentionStrategy2 = _interopRequireDefault(_mentionStrategy);

	var _mentionSuggestionsStrategy = mentionSuggestionsStrategy;

	var _mentionSuggestionsStrategy2 = _interopRequireDefault(_mentionSuggestionsStrategy);

	var _mentionStyles = {
	  "mention": "draftJsMentionPlugin__mention__29BEd"
	};

	var _mentionStyles2 = _interopRequireDefault(_mentionStyles);

	var _mentionSuggestionsStyles = {
	  "mentionSuggestions": "draftJsMentionPlugin__mentionSuggestions__2DWjA"
	};

	var _mentionSuggestionsStyles2 = _interopRequireDefault(_mentionSuggestionsStyles);

	var _mentionSuggestionsEntryStyles = {
	  "mentionSuggestionsEntry": "draftJsMentionPlugin__mentionSuggestionsEntry__3mSwm",
	  "mentionSuggestionsEntryFocused": "draftJsMentionPlugin__mentionSuggestionsEntryFocused__3LcTd draftJsMentionPlugin__mentionSuggestionsEntry__3mSwm",
	  "mentionSuggestionsEntryText": "draftJsMentionPlugin__mentionSuggestionsEntryText__3Jobq",
	  "mentionSuggestionsEntryAvatar": "draftJsMentionPlugin__mentionSuggestionsEntryAvatar__1xgA9"
	};

	var _mentionSuggestionsEntryStyles2 = _interopRequireDefault(_mentionSuggestionsEntryStyles);

	var _defaultSuggestionsFilter = defaultSuggestionsFilter$1;

	var _defaultSuggestionsFilter2 = _interopRequireDefault(_defaultSuggestionsFilter);

	var _positionSuggestions = positionSuggestions$1;

	var _positionSuggestions2 = _interopRequireDefault(_positionSuggestions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaultTheme = exports.defaultTheme = {
	  // CSS class for mention text
	  mention: _mentionStyles2.default.mention,
	  // CSS class for suggestions component
	  mentionSuggestions: _mentionSuggestionsStyles2.default.mentionSuggestions,
	  // CSS classes for an entry in the suggestions component
	  mentionSuggestionsEntry: _mentionSuggestionsEntryStyles2.default.mentionSuggestionsEntry,
	  mentionSuggestionsEntryFocused: _mentionSuggestionsEntryStyles2.default.mentionSuggestionsEntryFocused,
	  mentionSuggestionsEntryText: _mentionSuggestionsEntryStyles2.default.mentionSuggestionsEntryText,
	  mentionSuggestionsEntryAvatar: _mentionSuggestionsEntryStyles2.default.mentionSuggestionsEntryAvatar
	};

	exports.default = function () {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	  var callbacks = {
	    keyBindingFn: undefined,
	    handleKeyCommand: undefined,
	    handleReturn: undefined,
	    onChange: undefined
	  };

	  var ariaProps = {
	    ariaHasPopup: 'false',
	    ariaExpanded: false,
	    ariaOwneeID: undefined,
	    ariaActiveDescendantID: undefined
	  };

	  var searches = (0, _immutable.Map)();
	  var escapedSearch = void 0;
	  var clientRectFunctions = (0, _immutable.Map)();
	  var isOpened = void 0;

	  var store = {
	    getEditorState: undefined,
	    setEditorState: undefined,
	    getPortalClientRect: function getPortalClientRect(offsetKey) {
	      return clientRectFunctions.get(offsetKey)();
	    },
	    getAllSearches: function getAllSearches() {
	      return searches;
	    },
	    isEscaped: function isEscaped(offsetKey) {
	      return escapedSearch === offsetKey;
	    },
	    escapeSearch: function escapeSearch(offsetKey) {
	      escapedSearch = offsetKey;
	    },

	    resetEscapedSearch: function resetEscapedSearch() {
	      escapedSearch = undefined;
	    },

	    register: function register(offsetKey) {
	      searches = searches.set(offsetKey, offsetKey);
	    },

	    updatePortalClientRect: function updatePortalClientRect(offsetKey, func) {
	      clientRectFunctions = clientRectFunctions.set(offsetKey, func);
	    },

	    unregister: function unregister(offsetKey) {
	      searches = searches.delete(offsetKey);
	      clientRectFunctions = clientRectFunctions.delete(offsetKey);
	    },

	    getIsOpened: function getIsOpened() {
	      return isOpened;
	    },
	    setIsOpened: function setIsOpened(nextIsOpened) {
	      isOpened = nextIsOpened;
	    }
	  };

	  // Styles are overwritten instead of merged as merging causes a lot of confusion.
	  //
	  // Why? Because when merging a developer needs to know all of the underlying
	  // styles which needs a deep dive into the code. Merging also makes it prone to
	  // errors when upgrading as basically every styling change would become a major
	  // breaking change. 1px of an increased padding can break a whole layout.
	  var _config$mentionPrefix = config.mentionPrefix,
	      mentionPrefix = _config$mentionPrefix === undefined ? '' : _config$mentionPrefix,
	      _config$theme = config.theme,
	      theme = _config$theme === undefined ? defaultTheme : _config$theme,
	      _config$positionSugge = config.positionSuggestions,
	      positionSuggestions = _config$positionSugge === undefined ? _positionSuggestions2.default : _config$positionSugge,
	      mentionComponent = config.mentionComponent,
	      _config$mentionSugges = config.mentionSuggestionsComponent,
	      MentionSuggestionsComponent = _config$mentionSugges === undefined ? _MentionSuggestions2.default : _config$mentionSugges,
	      _config$entityMutabil = config.entityMutability,
	      entityMutability = _config$entityMutabil === undefined ? 'SEGMENTED' : _config$entityMutabil,
	      _config$mentionTrigge = config.mentionTrigger,
	      mentionTrigger = _config$mentionTrigge === undefined ? '@' : _config$mentionTrigge,
	      _config$mentionRegExp = config.mentionRegExp,
	      mentionRegExp = _config$mentionRegExp === undefined ? _defaultRegExp2.default : _config$mentionRegExp,
	      _config$supportWhites = config.supportWhitespace,
	      supportWhitespace = _config$supportWhites === undefined ? false : _config$supportWhites;

	  var mentionSearchProps = {
	    ariaProps: ariaProps,
	    callbacks: callbacks,
	    theme: theme,
	    store: store,
	    entityMutability: entityMutability,
	    positionSuggestions: positionSuggestions,
	    mentionTrigger: mentionTrigger,
	    mentionPrefix: mentionPrefix
	  };
	  var DecoratedMentionSuggestionsComponent = function DecoratedMentionSuggestionsComponent(props) {
	    return _react2.default.createElement(MentionSuggestionsComponent, _extends({}, props, mentionSearchProps));
	  };
	  var DecoratedMention = function DecoratedMention(props) {
	    return _react2.default.createElement(_Mention2.default, _extends({}, props, { theme: theme, mentionComponent: mentionComponent }));
	  };
	  var DecoratedMentionSuggestionsPortal = function DecoratedMentionSuggestionsPortal(props) {
	    return _react2.default.createElement(_MentionSuggestionsPortal2.default, _extends({}, props, { store: store }));
	  };
	  return {
	    MentionSuggestions: DecoratedMentionSuggestionsComponent,
	    decorators: [{
	      strategy: (0, _mentionStrategy2.default)(mentionTrigger),
	      component: DecoratedMention
	    }, {
	      strategy: (0, _mentionSuggestionsStrategy2.default)(mentionTrigger, supportWhitespace, mentionRegExp),
	      component: DecoratedMentionSuggestionsPortal
	    }],
	    getAccessibilityProps: function getAccessibilityProps() {
	      return {
	        role: 'combobox',
	        ariaAutoComplete: 'list',
	        ariaHasPopup: ariaProps.ariaHasPopup,
	        ariaExpanded: ariaProps.ariaExpanded,
	        ariaActiveDescendantID: ariaProps.ariaActiveDescendantID,
	        ariaOwneeID: ariaProps.ariaOwneeID
	      };
	    },

	    initialize: function initialize(_ref) {
	      var getEditorState = _ref.getEditorState,
	          setEditorState = _ref.setEditorState;

	      store.getEditorState = getEditorState;
	      store.setEditorState = setEditorState;
	    },

	    keyBindingFn: function keyBindingFn(keyboardEvent) {
	      return callbacks.keyBindingFn && callbacks.keyBindingFn(keyboardEvent);
	    },
	    handleReturn: function handleReturn(keyboardEvent) {
	      return callbacks.handleReturn && callbacks.handleReturn(keyboardEvent);
	    },
	    onChange: function onChange(editorState) {
	      if (callbacks.onChange) return callbacks.onChange(editorState);
	      return editorState;
	    }
	  };
	};

	exports.defaultSuggestionsFilter = _defaultSuggestionsFilter2.default;
} (lib));

var createMentionPlugin = /*@__PURE__*/getDefaultExportFromCjs(lib);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createExternalMentionsPlugin = (config) => {
  var _a;
  const type = MENTION_TYPE;
  const _b = config, {
    theme,
    [type]: mSettings = {},
    [_a = EXTERNAL_MENTIONS_TYPE]: mExtSettings = {}
  } = _b, rest = __objRest(_b, [
    "theme",
    __restKey(type),
    __restKey(_a)
  ]);
  const styles$1 = mergeStyles({ styles: styles, theme });
  const settings = __spreadValues(__spreadValues(__spreadValues({}, DEFAULT_SETTINGS), mSettings), mExtSettings);
  const plugin = createMentionPlugin({
    mentionComponent: decorateComponentWithProps(MentionComponent, { settings }),
    theme: styles$1,
    mentionPrefix: settings.mentionPrefix,
    mentionTrigger: settings.mentionTrigger,
    positionSuggestions: positionSuggestions$2({
      entryHeight: settings.entryHeight,
      additionalHeight: settings.additionalHeight,
      reposition: settings.repositionSuggestions,
      visibleItemsBeforeOverflow: settings.visibleItemsBeforeOverflow
    }),
    supportWhitespace: "supportWhitespace" in mSettings ? mSettings.supportWhitespace : true
  });
  const inlineModals = [
    decorateComponentWithProps(MentionSuggestionsWrapper, {
      component: plugin.MentionSuggestions,
      settings
    })
  ];
  return createBasePlugin(
    __spreadValues({
      theme,
      type,
      inlineModals,
      settings,
      decoratorTrigger: "@",
      defaultPluginData: DEFAULTS
    }, rest),
    plugin
  );
};
createExternalMentionsPlugin.functionName = MENTION_TYPE;

export { createExternalMentionsPlugin };
//# sourceMappingURL=createMentionsPlugin.js.map
